import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

const PCOLOR = { P0: "#A32D2D", P1: "#D4AF37", P2: "#5a5d96" };
const accColor = (acc) =>
  acc == null ? "#5a5d96" : acc >= 80 ? "#1A7A4A" : acc >= 50 ? "#D4AF37" : "#A32D2D";

const HermesPanel = () => {
  const [data, setData] = useState(null);
  const [grading, setGrading] = useState(null);
  const [reviews, setReviews] = useState(null);
  const [busy, setBusy] = useState(false);
  const [flash, setFlash] = useState(null);

  const load = async () => {
    try {
      const [r, g, rv] = await Promise.all([
        api.get("/admin/hermes/latest"),
        api.get("/admin/hermes/grades"),
        api.get("/admin/review-requests?limit=20"),
      ]);
      setData(r.data);
      setGrading(g.data);
      setReviews(rv.data);
    } catch (e) {
      setData({ error: e?.message });
    }
  };
  useEffect(() => { load(); }, []);

  const runNow = async (dryRun = false) => {
    setBusy(true); setFlash("Running Hermes cycle…");
    try {
      const r = await api.post(`/admin/hermes/run-now?dry_run=${dryRun}`);
      const em = r.data.email || {};
      setFlash(`Cycle complete · ${r.data.recommendations_count} recs · email ${em.skipped ? "skipped (dry run)" : em.ok ? "delivered" : "failed"}`);
      await load();
    } catch (e) {
      setFlash(`Failed: ${e?.message}`);
    } finally {
      setBusy(false);
      setTimeout(() => setFlash(null), 6000);
    }
  };

  const gradeNow = async (sendEmail = false) => {
    setBusy(true); setFlash("Running weekly grading…");
    try {
      const r = await api.post(`/admin/hermes/grade-now?send_email=${sendEmail}`);
      const em = r.data.email || {};
      setFlash(`Graded ${r.data.graded_count ?? 0} · email ${em?.skipped ? "skipped" : em?.ok ? "delivered" : "failed"}`);
      await load();
    } catch (e) {
      setFlash(`Grading failed: ${e?.message}`);
    } finally {
      setBusy(false);
      setTimeout(() => setFlash(null), 6000);
    }
  };

  const sweepReviews = async () => {
    setBusy(true); setFlash("Sending due review requests…");
    try {
      const r = await api.post("/admin/review-requests/sweep");
      setFlash(`Sweep: ${r.data.sent} sent · ${r.data.failed} failed · ${r.data.due} were due`);
      await load();
    } catch (e) {
      setFlash(`Sweep failed: ${e?.message}`);
    } finally {
      setBusy(false);
      setTimeout(() => setFlash(null), 6000);
    }
  };

  const act = async (recId, action) => {
    setBusy(true);
    try {
      await api.post(`/admin/hermes/recommendations/${recId}/action`, { action });
      await load();
    } finally { setBusy(false); }
  };

  const copy = (text, id) => {
    navigator.clipboard?.writeText(text);
    setFlash(`Prompt copied — paste into Emergent to execute`);
    setTimeout(() => setFlash(null), 3000);
  };

  if (!data) return <div style={{ padding: 20 }} data-testid="hermes-loading">Loading Hermes…</div>;
  const recs = data.recommendations || [];

  return (
    <div data-testid="hermes-panel" style={{ marginTop: 26, padding: 22, borderRadius: 10, background: "#0A1628", color: "#fff", border: "2px solid #D4AF37" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
        <h2 className="font-display" style={{ fontSize: 30, color: "#D4AF37", margin: 0, letterSpacing: 1 }}>
          HERMES · AGENT BRAIN
        </h2>
        <div style={{ display: "flex", gap: 8 }}>
          <button data-testid="hermes-run-dry" disabled={busy} onClick={() => runNow(true)}
            className="btn-outline-navy tap"
            style={{ fontSize: 13, padding: "8px 14px", minHeight: 38, borderColor: "#D4AF37", color: "#D4AF37" }}>
            DRY RUN
          </button>
          <button data-testid="hermes-run-now" disabled={busy} onClick={() => runNow(false)}
            className="btn-gold tap" style={{ fontSize: 13, padding: "8px 14px", minHeight: 38 }}>
            RUN + EMAIL NOW
          </button>
        </div>
      </div>
      <p style={{ color: "#cbd0db", margin: "6px 0 14px", fontSize: 14 }}>
        Daily 4am ET recommendations · weekly self-grading Sun 3am ET · emails ajakaiye@gmail.com + lanre@nearnow.biz
      </p>

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
        <button data-testid="hermes-grade-preview" disabled={busy} onClick={() => gradeNow(false)}
          className="btn-outline-navy tap"
          style={{ fontSize: 12, padding: "6px 12px", minHeight: 34, borderColor: "#D4AF37", color: "#D4AF37" }}>
          GRADE NOW (PREVIEW)
        </button>
        <button data-testid="hermes-grade-email" disabled={busy} onClick={() => gradeNow(true)}
          className="btn-gold tap" style={{ fontSize: 12, padding: "6px 12px", minHeight: 34 }}>
          GRADE + EMAIL REPORT
        </button>
        <button data-testid="hermes-review-sweep" disabled={busy} onClick={sweepReviews}
          className="btn-outline-navy tap"
          style={{ fontSize: 12, padding: "6px 12px", minHeight: 34, borderColor: "#1A7A4A", color: "#1A7A4A" }}>
          SWEEP REVIEWS
        </button>
      </div>

      {reviews && (
        <div data-testid="review-loop" style={{ background: "rgba(255,255,255,0.06)", padding: 14, borderRadius: 8, marginBottom: 14 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
            <h3 style={{ margin: 0, color: "#D4AF37", fontSize: 16, letterSpacing: 1, fontFamily: "Bebas Neue, sans-serif" }}>
              REVIEW LOOP · JOBS TODAY → REVIEWS
            </h3>
            <span style={{ color: "#cbd0db", fontSize: 12 }}>
              Hourly sweep · $5K+ jobs · 2-day follow-up
            </span>
          </div>
          <div data-testid="review-counts" style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0,1fr))", gap: 8, marginBottom: 10 }}>
            {[
              ["queued", "#D4AF37"],
              ["sent", "#1A7A4A"],
              ["failed", "#A32D2D"],
              ["cancelled", "#5a5d96"],
            ].map(([k, color]) => (
              <div key={k} data-testid={`review-count-${k}`}
                style={{ background: "#fff", color: "#0A1628", padding: "8px 10px", borderRadius: 6, borderLeft: `4px solid ${color}` }}>
                <div style={{ fontSize: 11, color: "#5a5d96", textTransform: "uppercase", letterSpacing: 1 }}>{k}</div>
                <div style={{ fontSize: 22, fontWeight: 700, color, fontFamily: "Bebas Neue, sans-serif", letterSpacing: 1 }}>
                  {reviews.counts?.[k] ?? 0}
                </div>
              </div>
            ))}
          </div>
          {reviews.items?.length > 0 && (
            <details>
              <summary style={{ cursor: "pointer", color: "#D4AF37", fontSize: 13 }}>
                Recent review requests ({reviews.items.length}) ↓
              </summary>
              <div data-testid="review-list" style={{ marginTop: 8, maxHeight: 220, overflow: "auto" }}>
                {reviews.items.slice(0, 10).map((rv) => {
                  const color = rv.status === "sent" ? "#1A7A4A"
                              : rv.status === "failed" ? "#A32D2D"
                              : rv.status === "cancelled" ? "#5a5d96" : "#D4AF37";
                  return (
                    <div key={rv.id} data-testid={`review-item-${rv.id}`}
                      style={{ background: "#fff", color: "#1A1A2E", padding: "8px 10px", borderRadius: 6, marginBottom: 6, borderLeft: `3px solid ${color}` }}>
                      <div style={{ fontSize: 11, color: "#5a5d96", textTransform: "uppercase", letterSpacing: 1 }}>
                        {rv.status} · ${Math.round((rv.job_value_cents || 0) / 100).toLocaleString()} · {(rv.scheduled_send_at || "").slice(0, 10)}
                      </div>
                      <div style={{ fontSize: 13, fontWeight: 600 }}>
                        {rv.customer_name || "—"} · {rv.job_title}
                      </div>
                      <div style={{ fontSize: 12, color: "#5a5d96", marginTop: 2 }}>
                        → {rv.contractor_email}
                      </div>
                    </div>
                  );
                })}
              </div>
            </details>
          )}
        </div>
      )}

      {flash && (
        <div data-testid="hermes-flash" style={{ background: "#D4AF37", color: "#0A1628", padding: "8px 12px", borderRadius: 6, marginBottom: 12 }}>
          {flash}
        </div>
      )}

      {grading && (grading.calibration?.length > 0 || grading.grades?.length > 0) && (
        <div data-testid="hermes-learning" style={{ background: "rgba(255,255,255,0.06)", padding: 14, borderRadius: 8, marginBottom: 14 }}>
          <h3 style={{ margin: "0 0 10px", color: "#D4AF37", fontSize: 16, letterSpacing: 1, fontFamily: "Bebas Neue, sans-serif" }}>
            LEARNED CALIBRATION
          </h3>
          {grading.calibration?.length > 0 ? (
            <div data-testid="hermes-calibration" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 8, marginBottom: 10 }}>
              {grading.calibration.map((c) => (
                <div key={c.skill_key || c.category} data-testid={`hermes-cal-${c.category}`}
                  style={{ background: "#fff", color: "#0A1628", padding: "8px 10px", borderRadius: 6, borderLeft: `4px solid ${accColor(c.avg_accuracy_pct)}` }}>
                  <div style={{ fontSize: 11, color: "#5a5d96", textTransform: "uppercase", letterSpacing: 1 }}>{c.category}</div>
                  <div style={{ fontSize: 20, fontWeight: 700, color: accColor(c.avg_accuracy_pct) }}>
                    {Math.round(c.avg_accuracy_pct || 0)}%
                  </div>
                  <div style={{ fontSize: 11, color: "#5a5d96" }}>of predicted MRR · n={c.graded_count || 0}</div>
                </div>
              ))}
            </div>
          ) : (
            <p style={{ color: "#cbd0db", fontSize: 13, margin: "0 0 8px" }}>
              No calibration yet. Mark a recommendation as <strong>EXECUTED</strong>, wait 7 days, then click <strong>GRADE NOW</strong>.
            </p>
          )}
          {grading.grades?.length > 0 && (
            <details style={{ marginTop: 4 }}>
              <summary style={{ cursor: "pointer", color: "#D4AF37", fontSize: 13 }}>
                View recent grades ({grading.grades.length}) ↓
              </summary>
              <div data-testid="hermes-grades-list" style={{ marginTop: 8, maxHeight: 240, overflow: "auto" }}>
                {grading.grades.slice(0, 20).map((g) => (
                  <div key={g.id} data-testid={`hermes-grade-${g.id}`}
                    style={{ background: "#fff", color: "#1A1A2E", padding: 8, borderRadius: 6, marginBottom: 6, borderLeft: `3px solid ${accColor(g.accuracy_pct)}` }}>
                    <div style={{ fontSize: 11, color: "#5a5d96", textTransform: "uppercase", letterSpacing: 1 }}>{g.category}</div>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>{g.title}</div>
                    <div style={{ fontSize: 12, color: "#5a5d96" }}>
                      Predicted ${Math.round(g.predicted_dollars || 0)} · Actual ${Math.round(g.actual_dollars || 0)} ·
                      <strong style={{ color: accColor(g.accuracy_pct), marginLeft: 4 }}>
                        {g.accuracy_pct == null ? "—" : `${Math.round(g.accuracy_pct)}%`}
                      </strong>
                    </div>
                  </div>
                ))}
              </div>
            </details>
          )}
        </div>
      )}

      {recs.length === 0 ? (
        <div style={{ padding: 16, background: "rgba(255,255,255,0.06)", borderRadius: 8 }}>
          No recommendations yet. Click <strong>RUN + EMAIL NOW</strong> to generate the first cycle.
        </div>
      ) : (
        <div data-testid="hermes-recs">
          {recs.map((r) => (
            <div key={r.id} data-testid={`hermes-rec-${r.id}`} style={{
              background: "#fff", color: "#1A1A2E", padding: 16, borderRadius: 8,
              marginBottom: 12, borderLeft: `4px solid ${PCOLOR[r.priority] || "#5a5d96"}`,
              opacity: r.status === "dismissed" ? 0.45 : 1,
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "start" }}>
                <h3 style={{ margin: 0, fontSize: 17 }}>{r.title}</h3>
                <span style={{ background: PCOLOR[r.priority] || "#5a5d96", color: "#fff", padding: "3px 10px", borderRadius: 4, fontSize: 11, fontFamily: "Bebas Neue, sans-serif", letterSpacing: 1 }}>{r.priority}</span>
              </div>
              <p style={{ color: "#5a5d96", fontSize: 12, margin: "6px 0 4px", textTransform: "uppercase", letterSpacing: 1 }}>
                {r.category} · impact: {r.expected_impact}
                {r.status !== "pending" && <span style={{ marginLeft: 8, color: r.status === "executed" ? "#1A7A4A" : "#A32D2D" }}>· {r.status}</span>}
                {r.auto_executed && (
                  <span data-testid={`hermes-auto-${r.id}`}
                    style={{ marginLeft: 8, background: "#1A7A4A", color: "#fff", padding: "2px 8px", borderRadius: 4, fontSize: 10, letterSpacing: 1 }}
                    title={r.auto_executed_reason || "Auto-executed by Hermes"}>
                    ⚡ AUTO
                  </span>
                )}
              </p>
              <p style={{ margin: "6px 0", fontSize: 14, lineHeight: 1.5 }}>{r.rationale}</p>
              <details style={{ marginTop: 8 }}>
                <summary style={{ cursor: "pointer", color: "#5a5d96", fontSize: 13 }}>View copy/paste prompt ↓</summary>
                <pre style={{ background: "#0A1628", color: "#D4AF37", padding: 12, borderRadius: 6, fontSize: 12, whiteSpace: "pre-wrap", marginTop: 8, maxHeight: 240, overflow: "auto" }}>{r.emergent_prompt}</pre>
              </details>
              <div style={{ marginTop: 10, display: "flex", gap: 6, flexWrap: "wrap" }}>
                <button data-testid={`hermes-copy-${r.id}`} onClick={() => copy(r.emergent_prompt, r.id)}
                  className="btn-outline-navy tap" style={{ fontSize: 12, padding: "6px 12px", minHeight: 34 }}>
                  COPY PROMPT
                </button>
                {r.status === "pending" && (
                  <>
                    <button data-testid={`hermes-approve-${r.id}`} disabled={busy} onClick={() => act(r.id, "approve")}
                      className="btn-gold tap" style={{ fontSize: 12, padding: "6px 12px", minHeight: 34 }}>
                      APPROVE
                    </button>
                    <button data-testid={`hermes-dismiss-${r.id}`} disabled={busy} onClick={() => act(r.id, "dismiss")}
                      style={{ fontSize: 12, padding: "6px 12px", minHeight: 34, background: "transparent", border: "1px solid #A32D2D", color: "#A32D2D", borderRadius: 4, cursor: "pointer" }}>
                      DISMISS
                    </button>
                  </>
                )}
                {r.status === "approved" && (
                  <button data-testid={`hermes-executed-${r.id}`} disabled={busy} onClick={() => act(r.id, "executed")}
                    className="btn-navy tap" style={{ fontSize: 12, padding: "6px 12px", minHeight: 34 }}>
                    MARK EXECUTED
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HermesPanel;
